export const GET_DASHBOARDS = 'GET_DASHBOARDS';
export const GET_DASHBOARD_BY_ID = 'GET_DASHBOARD_BY_ID';
export const UPDATE_DASHBOARD = 'UPDATE_DASHBOARD';
export const DELETE_DASHBOARD = 'DELETE_DASHBOARD';
export const CREATE_DASHBOARD = 'CREATE_DASHBOARD';
